import EditorialCrossLink from './EditorialCrossLink';

export default EditorialCrossLink;
